module.exports = __webpack_public_path__ + "img/跳转 (5).d66c6aa6.svg";